const ordersEn = {
  "ord.title": "Orders",
  "ord.create": "Create order",
  "ord.empty_title": "Your orders will show here",
  "ord.empty_body": "Orders from your storefront and manual orders you create for phone or WhatsApp sales appear here.",
  "ord.none": "No orders match these filters.",
  "ord.search": "Search by order number, customer, email, phone or product",
  "ord.tab.all": "All",
  "ord.tab.unfulfilled": "Unfulfilled",
  "ord.tab.unpaid": "Unpaid",
  "ord.tab.open": "Open",
  "ord.tab.archived": "Archived",
  "ord.tab.cod": "COD to collect",
  "ord.sort.-processed_at": "Newest",
  "ord.sort.processed_at": "Oldest",
  "ord.sort.-total": "Total: high to low",
  "ord.sort.total": "Total: low to high",
  "ord.sort.-number": "Order number: high to low",
  "ord.sort.number": "Order number: low to high",
  "ord.filter.payment": "Payment status",
  "ord.filter.fulfillment": "Fulfillment status",
  "ord.filter.delivery": "Delivery method",
  "ord.fin.pending": "Payment pending",
  "ord.fin.authorized": "Authorized",
  "ord.fin.partially_paid": "Partially paid",
  "ord.fin.paid": "Paid",
  "ord.fin.partially_refunded": "Partially refunded",
  "ord.fin.refunded": "Refunded",
  "ord.fin.voided": "Voided",
  "ord.ful.unfulfilled": "Unfulfilled",
  "ord.ful.partially_fulfilled": "Partially fulfilled",
  "ord.ful.fulfilled": "Fulfilled",
  "ord.ful.scheduled": "Scheduled",
  "ord.ful.on_hold": "On hold",
  "ord.delivery.shipping": "Shipping",
  "ord.delivery.local_delivery": "Local delivery",
  "ord.delivery.pickup": "Pickup",
  "ord.delivery.none": "No delivery",
  "ord.col.order": "Order",
  "ord.col.date": "Date",
  "ord.col.customer": "Customer",
  "ord.col.total": "Total",
  "ord.col.payment": "Payment",
  "ord.col.fulfillment": "Fulfillment",
  "ord.col.items": "Items",
  "ord.col.delivery": "Delivery method",
  "ord.col.tags": "Tags",
  "ord.no_customer": "No customer",
  "ord.cancelled": "Cancelled",
  "ord.items": "{n} items",
  "ord.source.web": "Storefront",
  "ord.source.draft": "Manual order",
  "ord.source.api": "API",
  "ord.source.pos": "Point of Sale",
  "ord.state.archived": "Archived",
  "ord.cancelled_banner": "This order was cancelled. Reason: {reason}.",
  "ord.reason.customer": "Customer changed or cancelled order",
  "ord.reason.inventory": "Items unavailable",
  "ord.reason.fraud": "Fraudulent order",
  "ord.reason.declined": "Payment declined",
  "ord.reason.staff": "Staff error",
  "ord.reason.other": "Other",
  "ord.more_actions": "More actions",
  "ord.duplicate": "Duplicate",
  "ord.print_slip": "Print packing slip",
  "ord.view_status_page": "View order status page",
  "ord.archive": "Archive",
  "ord.unarchive": "Unarchive",
  "ord.archived": "Order archived",
  "ord.unarchived": "Order unarchived",
  "ord.cancel": "Cancel order",
  "ord.refund": "Refund",
  "ord.removed": "Removed",
  "ord.items_title": "Items",
  "ord.notes": "Notes",
  "ord.no_notes": "No notes from customer",
  "ord.attributes": "Additional details",
  "ord.on_hold": "On hold",
  "ord.ready_for_pickup": "Ready for pickup",
  "ord.unfulfilled_n": "Unfulfilled ({n})",
  "ord.fulfilled_n": "Fulfilled ({n})",
  "ord.picked_up_n": "Picked up ({n})",
  "ord.release_hold": "Release fulfillment hold",
  "ord.hold": "Hold fulfillment",
  "ord.hold_released": "Fulfillment hold released",
  "ord.held": "Fulfillment put on hold",
  "ord.hold.awaiting_payment": "Awaiting payment",
  "ord.hold.awaiting_confirmation": "Awaiting customer confirmation",
  "ord.hold.high_risk": "High risk of fraud",
  "ord.hold.incorrect_address": "Incorrect address",
  "ord.hold.inventory_out_of_stock": "Inventory out of stock",
  "ord.hold.other": "Other",
  "ord.hold_title": "Hold fulfillment",
  "ord.hold_body": "Items on hold can't be fulfilled until you release the hold.",
  "ord.hold_reason": "Reason",
  "ord.mark_picked_up": "Mark as picked up",
  "ord.mark_ready": "Mark as ready for pickup",
  "ord.picked_up_done": "Marked as picked up",
  "ord.ready_done": "Marked as ready for pickup — the customer was notified",
  "ord.fulfill_items": "Fulfill items",
  "ord.deliver_items": "Deliver items",
  "ord.shipment.in_transit": "In transit",
  "ord.shipment.out_for_delivery": "Out for delivery",
  "ord.shipment.attempted_delivery": "Attempted delivery",
  "ord.shipment.delivered": "Delivered",
  "ord.shipment.failure": "Delivery failed",
  "ord.shipment.picked_up": "Picked up",
  "ord.mark_shipment": "Mark as {status}",
  "ord.add_tracking": "Add tracking",
  "ord.edit_tracking": "Edit tracking",
  "ord.cancel_fulfillment": "Cancel fulfillment",
  "ord.cancel_fulfillment_title": "Cancel fulfillment {name}?",
  "ord.cancel_fulfillment_body": "The items go back to unfulfilled and their stock is committed again.",
  "ord.fulfillment_cancelled": "Fulfillment cancelled",
  "ord.subtotal": "Subtotal",
  "ord.discount": "Discount",
  "ord.shipping": "Shipping",
  "ord.taxes": "Taxes",
  "ord.taxes_included": "Taxes (included)",
  "ord.payment_fee": "Payment fee",
  "ord.tip": "Tip",
  "ord.total": "Total",
  "ord.paid_by_customer": "Paid by customer",
  "ord.refunded": "Refunded",
  "ord.net_payment": "Net payment",
  "ord.balance": "Balance",
  "ord.cod_to_collect": "Cash to collect on delivery",
  "ord.show_transactions": "Show transactions ({n})",
  "ord.hide_transactions": "Hide transactions",
  "ord.mark_paid": "Mark as paid",
  "ord.collect_cod": "Mark cash as collected",
  "ord.mark_paid_title": "Mark as paid?",
  "ord.mark_paid_body": "This records a manual payment of {amount}. It can't be undone.",
  "ord.marked_paid": "Order marked as paid",
  "ord.txn.success": "Success",
  "ord.txn.pending": "Pending",
  "ord.txn.failure": "Failed",
  "ord.txn.error": "Error",
  "ord.txn_kind.sale": "Sale",
  "ord.txn_kind.refund": "Refund",
  "ord.txn_kind.authorization": "Authorization",
  "ord.txn_kind.capture": "Capture",
  "ord.txn_kind.void": "Void",
  "ord.txn_kind.chargeback": "Chargeback",
  "ord.txn_kind.chargeback_reversal": "Chargeback reversal",
  "ord.txn_kind.change": "Change",
  "ord.method.cod": "Cash on Delivery (COD)",
  "ord.method.skipcash": "SkipCash",
  "ord.method.sadad": "Sadad",
  "ord.method.myfatoorah": "MyFatoorah",
  "ord.method.tap": "Tap Payments",
  "ord.method.paylater": "PayLater",
  "ord.method.tabby": "Tabby",
  "ord.method.tamara": "Tamara",
  "ord.method.bank_transfer": "Bank transfer",
  "ord.method.manual": "Manual",
  "ord.test": "Test",
  "ord.customer": "Customer",
  "ord.customer_orders": "{n} orders",
  "ord.contact": "Contact information",
  "ord.no_email": "No email provided",
  "ord.whatsapp": "Message on WhatsApp",
  "ord.shipping_address": "Shipping address",
  "ord.billing_address": "Billing address",
  "ord.no_address": "No address provided",
  "ord.view_map": "View map",
  "ord.pickup_at": "Pickup location",
  "ord.same_as_shipping": "Same as shipping address",
  "ord.marketing_yes": "Subscribed to email marketing",
  "ord.marketing_no": "Not subscribed to email marketing",
  "ord.tags": "Tags",
  "ord.tags_placeholder": "Add tags",
  "ord.timeline": "Timeline",
  "ord.comment_placeholder": "Leave a comment…",
  "ord.comment_hint": "Only you and other staff can see comments",
  "ord.post": "Post",
  "ord.staff": "Staff",
  "ord.keep_order": "Keep order",
  "ord.cancel_title": "Cancel order {name}?",
  "ord.cancel_refund": "Refund {amount}",
  "ord.refund_gateway_hint": "Card payments are refunded in your {name} account; this records the refund here.",
  "ord.restock_items": "Restock items",
  "ord.cancel_reason": "Reason for canceling",
  "ord.staff_note": "Staff note",
  "ord.notify_customer": "Send a notification to the customer",
  "ord.cancelled_done": "Order cancelled",
  "ord.tracking_number": "Tracking number",
  "ord.carrier": "Shipping carrier",
  "ord.carrier_other": "Other",
  "ord.carrier_name": "Carrier name",
  "ord.tracking_url": "Tracking URL",
  "ord.notify_tracking": "Send shipping update to customer",
  "ord.tracking_saved": "Tracking updated",
  "ord.edit_note": "Edit note",
  "ord.edit_contact": "Edit contact information",
  "ord.email": "Email",
  "ord.phone": "Phone",
  "ord.contact_hint": "Changes only apply to this order, not the customer profile.",
  "ord.edit_shipping_address": "Edit shipping address",
  "ord.ship_to": "Ship to",
  "ord.qty": "Quantity",
  "ord.back": "Back to order",
  "ord.nothing_to_fulfill": "Everything on this order is fulfilled.",
  "ord.fulfill_title": "Fulfill {name}",
  "ord.of_n": "of {n}",
  "ord.tracking": "Tracking information",
  "ord.summary": "Summary",
  "ord.fulfilling_n": "Fulfilling {n} items from {loc}",
  "ord.notify_out_for_delivery": "Tell the customer it's out for delivery",
  "ord.notify_shipment": "Send shipment details to the customer",
  "ord.send_out_n": "Send out {n} items",
  "ord.fulfill_n": "Fulfill {n} items",
  "ord.out_for_delivery_done": "Out for delivery",
  "ord.fulfilled_done": "Items fulfilled",
  "ord.refund_title": "Refund {name}",
  "ord.fulfilled_count": "{n} fulfilled",
  "ord.all_refunded": "All items were already refunded.",
  "ord.restock_n": "Restock {n} items",
  "ord.refund_shipping": "Refund shipping",
  "ord.shipping_amount": "Shipping amount",
  "ord.shipping_left": "{amount} left to refund",
  "ord.refund_reason": "Reason for refund",
  "ord.refund_reason_hint": "Only you and other staff can see this",
  "ord.items_subtotal": "Items subtotal",
  "ord.refund_total": "Refund total",
  "ord.refund_amount": "Refund amount",
  "ord.available_refund": "{amount} available for refund",
  "ord.refund_unpaid_hint": "Nothing was collected yet: removing items lowers what's owed.",
  "ord.refund_amount_btn": "Refund {amount}",
  "ord.remove_items": "Remove items",
  "ord.refunded_done": "Refund recorded",
  "draft.title": "Manual orders",
  "draft.create": "Create order",
  "draft.empty_title": "Take orders by phone or WhatsApp",
  "draft.empty_body": "Create orders for your customers, add custom items and discounts, then mark them as paid or pending.",
  "draft.tab.all": "All",
  "draft.tab.open": "Open",
  "draft.tab.completed": "Completed",
  "draft.search": "Search manual orders",
  "draft.none": "No manual orders found.",
  "draft.col.draft": "Draft",
  "draft.col.date": "Date",
  "draft.col.customer": "Customer",
  "draft.col.status": "Status",
  "draft.col.total": "Total",
  "draft.completed": "Completed",
  "draft.open": "Open",
  "draft.new": "Create order",
  "draft.delete_title": "Delete this manual order?",
  "draft.delete_body": "This can't be undone.",
  "draft.view_order": "View order",
  "draft.completed_banner": "This manual order became order {name}.",
  "draft.products": "Products",
  "draft.custom_item": "Add custom item",
  "draft.search_products": "Search or browse products",
  "draft.no_items": "Add products to start the order.",
  "draft.custom": "Custom item",
  "draft.low_stock": "Only {n} available",
  "draft.payment": "Payment",
  "draft.add_discount": "Add discount",
  "draft.edit_discount": "Discount",
  "draft.add_shipping": "Add shipping",
  "draft.edit_shipping": "Shipping",
  "draft.tax_exempt_short": "Not collected",
  "draft.tax_exempt": "Don't collect taxes",
  "draft.save": "Save draft",
  "draft.saved": "Draft saved",
  "draft.collect_payment": "Collect payment",
  "draft.mark_paid": "Mark as paid",
  "draft.mark_pending": "Mark as payment pending",
  "draft.mark_paid_body": "Creates the order with {amount} recorded as paid.",
  "draft.mark_pending_body": "Creates the order with {amount} to collect later (cash on delivery or transfer).",
  "draft.create_order": "Create order",
  "draft.order_created": "Order {name} created",
  "draft.note_placeholder": "Add a note to this order",
  "draft.search_customers": "Search or add a customer",
  "draft.no_customers": "No customers found",
  "draft.add": "Add item",
  "draft.item_name": "Item name",
  "draft.price": "Price",
  "draft.taxable": "Item is taxable",
  "draft.physical": "Item is a physical product",
  "draft.line_discount": "Item discount",
  "draft.remove_discount": "Remove discount",
  "draft.apply": "Apply",
  "draft.discount_type": "Discount type",
  "draft.percentage": "Percentage",
  "draft.amount_per_item": "Amount per item ({currency})",
  "draft.amount": "Amount ({currency})",
  "draft.value": "Value",
  "draft.reason": "Reason",
  "draft.reason_hint": "Your customer can see this reason",
  "draft.shipping": "Shipping",
  "draft.remove_shipping": "Remove shipping",
  "draft.rate_name": "Rate name",
  "draft.rate_placeholder": "e.g. Courier",
} as const;

export default ordersEn;
